module.exports = __webpack_public_path__ + "img/sp-btn-add.d2ca2791.svg";